const menus = {
  'manage-users': [
    {
      name: 'Personal Information',
      href: 'personal-information',
      code: 'USER_MANAGE.MANAGE_EMPLOYEES.DETAILS.OPERATION_AUTHORITY'
    },
    // {
    //   enName: 'Data Analysis',
    //   href: 'data-analysis'
    // },
    {
      name: 'Related Manuscripts',
      href: 'related-manuscripts',
      code: 'USER_MANAGE.MANAGE_EMPLOYEES.DETAILS.OPERATION_AUTHORITY'
    },
    {
      name: 'Related Special Issue',
      href: 'related-special-issue',
      code: 'USER_MANAGE.MANAGE_EMPLOYEES.DETAILS.OPERATION_AUTHORITY'
    }
  ],
  'manage-employees': [
    {
      name: 'Action Authority',
      href: 'action-authority',
      code: 'USER_MANAGE.MANAGE_EMPLOYEES.DETAILS.OPERATION_AUTHORITY'
    },
    {
      name: 'Login Diary',
      href: 'login-diary',
      code: 'USER_MANAGE.MANAGE_EMPLOYEES.DETAILS.LOGIN_DIARY'
    }
    // {
    //   enName: 'Operation Record',
    //   href: 'operation-record',
    // code:'USER_MANAGE.MANAGE_EMPLOYEES.DETAILS.OPERATION_RECORD'
    // }
  ]
}
import { mapGetters, mapActions } from 'vuex'
import person from '@/api/person'
import user from '@/api/user'
import help from '@/utils/help'
import { getUploadConfig } from '@/utils/upload'
import siteTab from '@/components/tab'

export default {
  components: {
    siteTab
  },
  data() {
    return {
      user: {},
      type: '',
      path: '',
      menus,
      canWidth: 105,
      canHeight: 130,
      roleArr: {},
      download: help.download,
      roleType: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      editUser: 'getEditUser',
      title: 'getTitle',
      domain: 'getDomain'
    })
  },
  watch: {
    // 监听相同路由下参数变化的时候，从而实现异步刷新
    $route() {
      this.path = this.$route.path
    },
    editUser: {
      handler(val) {
        this.user = JSON.parse(JSON.stringify(val))
      }
    },
    immediate: true
  },
  mounted() {
    this.id = this.$route.params.id
    this.path = this.$route.path
    this.type = this.$route.path.split('/')[2]
    this.getQuery()
  },
  methods: {
    ...mapActions(['updateEditUser']),
    async getQuery() {
      if (this.type === 'manage-employees') {
        this.user = await user.query(this.id)
      } else {
        this.user = await person.query(this.id)
      }
      const { roleList } = this.user
      this.roleArr = {}
      let roleType = []
      if (roleList) {
        roleList.forEach(item => {
          // if (
          //   ['REVIEWER', 'EDITORIAL_BOARD', 'GUEST_EDITO'].includes(item.type)
          // ) {
          //   this.showClassification = true
          // }
          if (this.roleArr[item.name]) {
            if (item.journal) {
              this.roleArr[item.name].journals.push(item.journal.name)
            }
          } else {
            this.roleArr[item.name] = {
              name: item.name,
              journals: []
            }
            if (item.journal) {
              this.roleArr[item.name].journals.push(item.journal.name)
            }
          }
          if (roleType.indexOf(item) === -1) {
            roleType.push(item.type)
          }
          this.roleType = roleType
          // if (item.type === 'REVIEWER') {
          //   this.isReviewer = true
          //   this.rules.reviewFrequency = [
          //     {
          //       required: true,
          //       message:
          //         'Review Frequency' + this.LANGUAGE[this.language].noEmpty
          //     }
          //   ]
          //   this.rules.journalIdList = [
          //     {
          //       required: true,
          //       message:
          //         'Journal(s) Would Like to Review' +
          //         this.LANGUAGE[this.language].noEmpty
          //     }
          //   ]
          //   this.rules.rcv = [
          //     {
          //       required: true,
          //       message: 'CV' + this.LANGUAGE[this.language].noEmpty
          //     }
          //   ]
          // }
        })
      }
    },
    async handleUpload(files) {
      const file = files[0]
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/profile/${this.user.id}/icon/${help.guid()}`
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      await person.icon(this.user.personId || this.user.id, {
        icon: url,
        iconName: file.name,
        version: this.user.version
      })

      this.$message.success({
        title: 'Success',
        content: 'Replace Successfully'
      })
      this.getQuery()
    }
  }
}
